export default __webpack_public_path__ + "static/media/right-side.401db878.png";